export const EMAILS_PATH = 'emails';
